import { FC } from "react";
import { RegisterRadiologistContainer } from "../../pages/radiologist/register/style";
import { FlexContainer } from "../styled-components/flex-container";
import { ReactComponent as Elipse } from "./../../assets/images/elipse.svg";
import { ReactComponent as Comment } from "./../../assets/images/comment.svg";
// import logo from "./../../assets/images/logo.png";
import logoblue from "./../../assets/images/logo-blue.png";
import RadiologistHeader, {
  RadiologistHeaderProps,
} from "../RadiologistHeader";
import { useQuery } from "../../pages/hooks/use-query";
import { Link } from "react-router-dom";

type IProps = Pick<RadiologistHeaderProps, "handleSkipStep" | "step">;

interface IRadiologistStepContainer extends IProps {
  showStep?: boolean;
  total_steps?: number;
  step: number;
}

export const RadiologistStepContainer: FC<IRadiologistStepContainer> = ({
  showStep = true,
  step,
  total_steps = 5,
  handleSkipStep,
  children,
}) => {
  const type = useQuery("type");

  return (
    <RegisterRadiologistContainer>
      <FlexContainer>
        <div className="left">
          <Elipse className="abs-el" />
          <Comment className="abs-com" />
          <Link to="/" aria-label="solace logo">
            <img src={logoblue} alt="Solace Imaging" className="logo" />
          </Link>
          {type === "add" ? (
            <>
              {" "}
              <h1>Add a specialist to your organisation.</h1>
              <p>
                <p>
                  Fill in the details for the specialist and we will send them a
                  mail to get them started.
                </p>
              </p>
            </>
          ) : (
            <>
              {" "}
              <h1>I see it's your first time here.</h1>
              <p>
                Either you're diagnostic center, hospital or specialist,
                register or login with your credential and start your medical
                reporting journey instantly.
              </p>
            </>
          )}
        </div>
        <div className="right">
          <div className="sm">
            {" "}
            <Link to="/" className="mobile-logo">
              <img src={logoblue} alt="Solace Imaging" className="logo" />
            </Link>
          </div>
          {showStep && (
            <RadiologistHeader
              step={step as number}
              total_steps={total_steps}
              handleSkipStep={handleSkipStep}
            />
          )}
          {children}
        </div>
      </FlexContainer>
    </RegisterRadiologistContainer>
  );
};
